export type NotificationStatus = 'L' | 'NL';

export enum NOTIFICATION_STATUS {
    NOT_READ = "NL",
    READ = "L",
}
  